export default {
  getSingleAttributeData(key, name, value) {
    return {
      key: key,
      name: name,
      value: value
    };
  },

  getAttributeUpdateDto(entityType, entityId, ...attributes) {
    const attributeList = [];
    for (let index in attributes) {
      attributeList.push(attributes[index]);
    }

    return this.getAttributeUpdateDtoFromList(entityType, entityId, attributeList);
  },

  getAttributeUpdateDtoFromList(entityType, entityId, attributes) {
    return {
      entityType: entityType,
      entityId: entityId,
      attributes: attributes
    };
  }
};

export const AttributeDetails = {
  EMI_REPAYMENT_DATE: {
    key: "emi.repayment.date",
    name: "Emi Repayment"
  },

  ADDRESS_PROOF_BACK_DOCUMENT_SKIPPED: {
    key: "address.proof.back.document.skipped",
    name: "Address Proof Back Document Skipped"
  },

  BANK_STATEMENT_TYPE: {
    key: "bank.statement.type",
    name: "Bank Statement Type"
  },

  DECLARED_GST: {
    key: "DECLARED_GST",
    name: "GST"
  },

  ON_BOARDING_OFFICE_NAME: {
    key: "onboarding.officeName",
    name: "SHOP NAME"
  },

  SKIP_TASK: {
    key: "skip.task.%s",
    name: "%s Stage Skipped"
  },

  EMI_SCHEME_OPTION: {
    key: "emi.scheme.option",
    name: "EMI Scheme Option"
  },

  CONSENT_ACCEPTED: {
    key: "consent.accepted",
    name: "Consent Accepted"
  },

  CONSENT_ACCEPTED_OTP: {
    key: "consent.accepted.otp",
    name: "Consent Accepted OTP"
  },

  CONSENT_ACCEPTED_IP_ADDRESS: {
    key: "consent.accepted.ipaddress",
    name: "Consent Accepted IP Address"
  },

  CONSENT_ACCEPTED_TIMESTAMP: {
    key: "consent.accepted.timestamp",
    name: "Consent Accepted Timestamp"
  },

  BANK_OTP: {
    key: "bank.otp",
    name: "Bank Otp"
  },

  UPLOADED_ADDITIONAL_DOCUMENT_TYPE_OF: {
    key: "uploaded.additional.document.type.of.",
    name: "Uploaded Additional Document Type"
  },

  KYC_MODE_SELECTED: {
    key: "kyc.mode.selected",
    name: "Kyc Mode Selected"
  },
  
  PENNY_DROP_FAILURE_OPTION_SELECTED: {
    key: "penny.drop.failure.option.selected",
    name: "Penny drop failure option selected"
  }
};


